import type { LDMultiKindContext } from 'launchdarkly-react-client-sdk'
import { env } from './env'

export const LD_CLIENT_ID = env('VITE_LAUNCHDARKLY_CLIENT_ID')

/**
 * Builds a multi-context for LaunchDarkly so flags can be targeted at
 * the tenant level, the user level, or both simultaneously.
 *
 * Tenant context: use for per-customer feature availability.
 * User context:   use for per-user overrides / experiments.
 */
export const ldContext = (tenantId: string, userId?: string): LDMultiKindContext => ({
  kind: 'multi',
  tenant: {
    key: tenantId,
    name: tenantId,
  },
  user: {
    key: userId ?? 'anonymous',
    anonymous: !userId,
  },
})

/**
 * All feature flags used in the application.
 * Add new flags here to get full TypeScript coverage via useFlags<LDFlags>().
 */
export type LDFlags = {
  /** Recommendations carousel — off for tenants that don't have the feature */
  enableRecommendations: boolean
  /** Community page — nav link, route access, and Stream Chat widget */
  enableCommunity: boolean
  /** SCORM content player */
  enableScorm: boolean
  /** Transcript / certificate download */
  enableTranscript: boolean
  /** When true, Calendar nav link opens the tenant-configured external URL in a new tab */
  externalCalendarUrl: boolean
  /** When true, Catalog nav link opens the tenant-configured external URL in a new tab */
  externalCatalogUrl: boolean
  /** Marketing referral question shown during checkout */
  displayMarketingCheckoutQuestion: boolean
  /**
   * Waiting-list slot expiration on Registration/History, home, and profile.
   * Flag key: show-waitlist-expiration. Targeted to tenant keys ar_esc and ar_ade.
   */
  showWaitlistExpiration: boolean
}
